import { API_ENDPOINTS } from '@/shared/api/endPoints';
import { getUTMReferrerFromDocumentReferrer } from '@/shared/utils/utmParams';

export interface SendLeadFormDataPayload {
  /** Имя и фамилия контактного лица, оставившего заявку. */
  name: string;
  /** Дата и время отправки заявки в формате ISO без миллисекунд и таймзоны. */
  submitDate: string;
  /** Страница/домен, с которого пришла заявка (referer). */
  referer: string;
  /** Телефон контактного лица. */
  phone: string;
  /** Email контактного лица. */
  email: string;
  /** Цель обращения / комментарий пользователя. */
  purpose?: string;
  /** Интересующий продукт 2ГИС (значение из списка вариантов формы). */
  product?: string;
  /** Название компании клиента. */
  company?: string;
  /** Город клиента. */
  city?: string;
  /** Должность контактного лица. */
  position?: string;
  /** ИНН компании клиента. */
  inn?: string;
  /** Сайт компании клиента. */
  site?: string;
  /** Имя сотрудника банка-партнёра, оформляющего заявку (для форм банков). */
  employee_name?: string;
  /** Email сотрудника банка-партнёра. */
  employee_email?: string;
  /** Телефон сотрудника банка-партнёра. */
  employee_phone?: string;
  /** Сегмент сотрудника банка-партнёра. */
  employee_segment?: string;
  /** Территориальный банк сотрудника-партнёра. */
  employee_territorial_bank?: string;
  /** Подразделение сотрудника банка-партнёра. */
  employee_department?: string;
  /** Идентификатор клиента из систем аналитики (Яндекс.Метрика/GA). */
  client_id?: string;
  /** Идентификатор ответственного менеджера в CRM, на которого назначается лид. */
  assignedBy?: number | string;
  /** Код источника лида для CRM (например, номер формы/кампании). */
  source?: string;
  /** UTM-метка источника перехода. */
  utm_source?: string;
  /** UTM-метка канала перехода. */
  utm_medium?: string;
  /** UTM-метка рекламной кампании. */
  utm_campaign?: string;
  /** UTM-метка ключевого слова. */
  utm_term?: string;
  /** UTM-метка содержания объявления. */
  utm_content?: string;
  /** Домен-источник перехода, если utm_source не задан (см. addUTMReferrer). */
  utm_referrer?: string;
  /** Отправлять лид в Bitrix. */
  is_bitrix?: boolean;
  /** Помечает лид с ивента (/leads_event), в Bitrix не передаётся: там код в UTM. */
  event_code?: string;
}

const addUTMReferrer = (
  formData: SendLeadFormDataPayload,
): SendLeadFormDataPayload => ({
  ...formData,
  utm_referrer: formData.utm_source
    ? undefined
    : formData.utm_referrer || getUTMReferrerFromDocumentReferrer(),
});

export default async function sendLeadFormData(
  formData: SendLeadFormDataPayload,
) {
  const body = JSON.stringify(addUTMReferrer(formData));

  const data = await fetch(API_ENDPOINTS.LEAD_FORM, {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!data.ok) {
    throw new Error(
      `Ошибка отправки формы: ${data.status} ${data.statusText || ''}`.trim(),
    );
  }

  return data.json();
}
